import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { Route } from '../../class/route';

@Injectable()
export class RouteService extends WebService {

    public getRoute (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        const options = new RequestOptions({search: params, headers: this.headers});

        params.append('_with', String('stations,employee,created_by,updated_by'));

        return this.http.get( `${this.apiUrl}/routes?${params}`, options);
    }

    public newRoute(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/routes`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateRoute(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/routes/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteRoute(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/routes/${id}`, { headers: this.headers } );
    }

    public infoRoute(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/routes?id=${id}`,  { headers: this.headers } );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/route/route.service.ts